//src/cos/index.js
// import User from "@/core/User";
// import { user } from '@/core/utils.ts';

var COS = require('cos-js-sdk-v5');
import { Message } from "element-ui";

var cos = new COS({
    SecretId: 'AKID0ua2IMRN9j5C5lHZcb4PWO3fBa1iOuIV',
    SecretKey: 'PcbNvEKagYIhx0nuwoTxEIvJxSo9Semq',
});

var tengxunCos = {
    // Bucket:'https://cdn2.polz.cn/',
    Bucket: 'polz-files-1302700757',//这边注意了，bucket的名称一定不能用-拼接，cos默认-后面是appId
    Region: 'ap-shanghai',
    iconBaseUrl: "https://polz-files-1302700757.cos.ap-shanghai.myqcloud.com"
    // iconBaseUrl:'https://cdn2.polz.cn/'
}
//签名方法
var autograph = {
    addAutograph(name) {
        if (name) {
            if (name.indexOf('?') == -1) {
                //重新签名
                return cos.getObjectUrl({
                    Bucket: tengxunCos.Bucket,  /* 填入您自己的存储桶，必须字段 */
                    Region: tengxunCos.Region,  /* 存储桶所在地域，例如ap-beijing，必须字段 */
                    Key: name ,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
                })
            } else {
                //    拼接路径
                return tengxunCos.iconBaseUrl + '/' + name ;
            }
        }
    }
}

//上传文件方法
var putFile = function ( file  ) {
        return new Promise((resolve, reject) => {
            let info = {};
            const date=new Date();
            const time = Date.parse(String(date));
            info.name = 'cos/AccountApply/' + time + '.' + file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length)
            info.fileType = file.name.substring( file.name.lastIndexOf('.') + 1, file.name.length )
            info.title = file.name
            info.size = file.size
            cos.putObject({
                Bucket: tengxunCos.Bucket, /* 必须 */
                Region: tengxunCos.Region, /* 存储桶所在地域，必须字段 */
                Key: info.name, /* 必须 */
                Body: file, /* 上传文件对象，必须字段 */
                // onProgress: function (info) {
                // }
            }, (err, data)=>{
                if (err) {
                    Message.error(err.message)
                    reject(err)
                } else {
                    console.log(data)
                    //无签名
                    info.filePath = tengxunCos.iconBaseUrl + '/' + info.name
                    //访问路径
                    info.accessPath = autograph.addAutograph(info.name)
                    resolve(info)
                }
            })
        })
    }


export default  {
    cos, tengxunCos, autograph , putFile
}
